<!-- 滑块组件 -->
<template>
  <div class="sh_slider">
    <div class="sh_slider_box" :class="open ? 'sh_slider_box_overflow' : ''" :style="getContentStyle">
      <div ref="shSliderContentBox">
        <slot></slot>
      </div>
    </div>
    <div v-if="$scopedSlots.hasOwnProperty('btns') || $slots.hasOwnProperty('btns')" class="sh_slider_btns_custom">
      <slot name="btns" :open="open" :onOpen="onOpen"></slot>
    </div>
    <div v-else-if="$scopedSlots.hasOwnProperty('btns-left') || $slots.hasOwnProperty('btns-left')" class="sh_slider_btns_custom">
      <slot name="btns-left"></slot>
      <el-button
        class="slider"
        v-if="showSlideBtn"
        :type="btnType"
        @click="onOpen"
        :class="open ? 'open' : 'close'"
        icon="el-icon-arrow-left"
        :size="size"
      ></el-button>
    </div>
    <div v-else class="sh_slider_btns" :style="getBtnsStyle">
      <el-button v-if="showSearch" :type="searchConfig.type" :size="size" @click="onSearch" :icon="searchConfig.icon"></el-button>
      <el-button v-if="showRefresh" :type="refreshConfig.type" :size="size" @click="onRefresh" :icon="refreshConfig.icon"></el-button>
      <el-button
        v-if="showSlideBtn"
        :type="btnType"
        @click="onOpen"
        :size="size"
        :class="open ? 'open' : 'close'"
        icon="el-icon-arrow-left"
      ></el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShSlider',

  props: {
    // 收起，默认收起
    packup: {
      type: Boolean,
      default: true
    },
    minheight: {
      type: String,
      default: '50px'
    },
    maxheight: {
      type: String,
      default: '300px'
    },
    // 收起按钮类型 默认无样式 可选：primary/success/info/warning/danger
    btnType: {
      type: String,
      default: 'primary'
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    // 搜索按钮的配置
    searchConfig: {
      type: Object,
      default: () => ({
        // 搜索按钮类型 默认无样式 可选：primary/success/info/warning/danger
        type: 'primary',
        icon: 'el-icon-search'
      })
    },
    // 是否显示刷新按钮，默认不显示
    showRefresh: {
      type: Boolean,
      default: false
    },
    // 刷新按钮的配置
    refreshConfig: {
      type: Object,
      default: () => ({
        // 刷新按钮类型 默认无样式 可选：primary/success/info/warning/danger
        type: 'primary',
        icon: 'el-icon-refresh'
      })
    },
    // 按钮的间距， 默认16px
    btnPadding: {
      type: Number,
      default: 16
    },
    // 按钮大小， 默认medium
    size: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      // 按钮宽度
      btnWidth: 28,
      // 是否展开
      open: !this.packup,
      showSlideBtn: false
    }
  },

  computed: {
    // 内容容器Style
    getContentStyle() {
      let maxHeight = this.open ? this.maxHeight : this.minheight
      return {
        maxHeight: maxHeight
      }
    },
    // 按钮容器Style
    getBtnsStyle() {
      return {
        // width: this.showRefresh ? `${this.btnWidth * 3 + this.btnPadding}px` : `${this.btnWidth + this.btnPadding}px`
        width: 'auto'
      }
    },
    // 收起按钮Style
    getUpStyle() {
      return {
        marginLeft: `${this.btnPadding}px`
      }
    }
  },

  watch: {
    packup(v) {
      this.open = !v
    },
    open(v) {
      this.$emit('update:packup', !v)
    }
  },
  mounted() {
    this.showSlide()
    window.addEventListener('resize', () => {
      this.showSlide()
    })
  },
  methods: {
    /**
     * 打开/收起
     */
    onOpen() {
      this.open = !this.open
    },
    // 刷新按钮向外抛出事件
    onRefresh() {
      this.$emit('refresh')
    },
    onSearch() {
      this.$emit('search')
    },
    showSlide() {
      this.$nextTick(() => {
        const shSliderContentBox = this.$refs.shSliderContentBox || null
        if (!shSliderContentBox) {
          return false
        }
        if (Math.round(shSliderContentBox.clientHeight / parseInt(this.minheight)) > 1) {
          // 超过一行，显示下拉按钮
          this.showSlideBtn = true
        } else {
          this.showSlideBtn = false
        }
      })
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {})
  }
}
</script>

<style lang="scss">
// @import '#/assets/css/var-green.scss';
.sh_slider {
  width: 100%;
  display: flex;
  .sh_slider_box {
    flex: 1;
    transition: max-height 0.3s linear;
    overflow: hidden;
  }
  .sh_slider_box_overflow {
    overflow-y: auto;
  }
  .sh_slider_btns_custom {
    display: flex;
    align-items: flex-start;
    // padding-top: $MP28;
    .el-button.refresh,
    .el-button.slider {
      // width: 28px;
      // height: 28px;
      // padding: 5px 0;
      margin-left: 10px;
      &.open .el-icon-arrow-left {
        transform: rotate(90deg);
      }
      &.close .el-icon-arrow-left {
        transform: rotate(-90deg);
      }
    }
    .el-icon-arrow-left {
      transition: all 0.3s linear;
    }
  }
  .sh_slider_btns {
    // width: 36px;
    display: flex;
    align-items: flex-start;
    .el-button {
      // width: 28px;
      // height: 28px;
      // margin-top: $MP28;
      // padding: 5px 0;
      &.open .el-icon-arrow-left {
        transform: rotate(90deg);
      }
      &.close .el-icon-arrow-left {
        transform: rotate(-90deg);
      }
    }
    .el-icon-arrow-left {
      transition: all 0.3s linear;
      // color: $--color-primary;
      // font-size: 12px;
      // font-weight: 400;
    }
  }
}
</style>
